import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
function ProtectVerifyOtpRoute({ element: Element }) {
  const isAuthenticated = useSelector((state) => state.authReducer.isLogin);
  const otpVerified = useSelector((state) => state?.commonReducer?.allowOTPPage);

  return !isAuthenticated && otpVerified ? (
    <Element />
  ) : (
    <Navigate replace to={'/dashboard'} />
  );
}
export default ProtectVerifyOtpRoute;
